import { contactDeveloper } from "@common/common";
import { InputFieldSizeType } from "@common/input-definitions";

export function orderDocumentBase(orderId: any) {
  return '/montage/documents/' + orderId;
}

export const enum DeleteType {
  DOCUMENT='deletedocument',
  ORDER='deleteorder',
  RESTORE_DOCUMENT='restoredocument',
  RESTORE_ORDER='restoreorder',
}

export const enum OrderDialogTypes {
  AGB = 'agb',
  RECEIPT = 'receipt',
  REPORT = 'report',
  ACCEPTANCE = 'acceptance',
}

export interface OrderInputSizes {
  carDescLength?: InputFieldSizeType;
  carKindLength?: InputFieldSizeType;
  damageLength?: InputFieldSizeType;
  damageLocLength?: InputFieldSizeType;
  damageNrLength?: InputFieldSizeType;
  halterLength?: InputFieldSizeType;
  insuranceLength?: InputFieldSizeType;
  plateLength?: InputFieldSizeType;
  //
  addressLength?: InputFieldSizeType;
  cityLength?: InputFieldSizeType;
  zipLength?: InputFieldSizeType;
}

export interface OrderType {
  can_save?:boolean;
  deleted?:boolean;
  can_restore?:boolean;
  articlenr?: string;
  deductible?: string | number;
  deductible_type?:number;
  deductible_customer_status?: string | number;
  deductible_customer_part?: string | number;
  customer_id?: number;
  customer?: any;
  partner_id?: number;
  partner?: any;
  plate?: string;
  km?: number | string;
  first_reg?: string | Date;
  car_description?: string;
  damage?: string;
  work_day?: string | Date;
  halter?: string;
  insurance?: string;
  damage_nr?: string;
  damage_location?: string;
  damage_day?: string | Date;
  status?: string | number;
  work_from?: string | number;
  work_to?: string | number;
  kind?: string;
  montage_loctype?: string | number;
  montage_address?: string;
  montage_zip?: string;
  montage_city?: string;
  doctypes?: any[];
  team?:any;
}

export const orderStatuses: any[] = [
  {
    id: 1, name: 'offen'
  },
  {
    id: 2, name: 'ausgeführt'
  },
  {
    id: 3, name: 'storniert'
  }
];

export const orderDocsErrors = {
  CUSTOMER_SIGN: 'Problem beim Erfassen der Kundenunterschrift. ' + contactDeveloper,
  DAMAGE: 'Problem beim Erfassen des Schadens. ' + contactDeveloper,
  DEFECTS: 'Problem beim Erfassen der Mängel. ' + contactDeveloper,
  MONTAGE_SIGN: 'Problem beim Erfassen der Unterschrift des Montageleiters. ' + contactDeveloper
};

export function findOrderStatusNameById(id: any, defaultValue = ''): string {
  if (!id) {
    id = 1;
  }
  const entry = orderStatuses.find((item: any) => {
    return item.id == id;
  });

  return entry ? entry.name: '';
}
